import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp, CnpjCpfService } from '../../../../../../core';
import { Cliente } from '../../../cliente';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ClienteIntegracaoEmpresasImportHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp,
                private cnpjCpfService: CnpjCpfService) {
        this.pathApi = `${configServerService.getPathApiIntegrationEmpresas()}/cliente`;
    }

    /** Realiza a consulta dos dados de uma empresa através de seu CNPJ e transforma seus dados para um cliente */
    consultaCNPJ(cnpj: string): Observable<Cliente> {
        cnpj = this.cnpjCpfService.deformatar(cnpj);
        return this.customHttp.get<Cliente>(`${this.pathApi}/${cnpj}`)
                    .pipe(
                        map(cliente => {
                            // Classificações
                            cliente?.classificacoes?.forEach(classificacao => {
                                // Setando que pode editar a classificação
                                classificacao.canEdit = true;
                            })

                            return cliente;
                        })
                    );
    }
}
